import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {filter, Observable, of, switchMap, withLatestFrom} from 'rxjs';
import {
  completeOrder,
  navToFailedAddons,
} from '../../common/shopping-cart/cart.actions';
import {
  selectCartLoadingState,
  selectCheckEmptyCart,
  selectFailedAddons,
} from '../../common/shopping-cart/cart.selectors';
import {selectEnableAddressCollection} from '../address.selectors';
import {selectCurrentRegistration} from 'src/app/common/context-data/context-data.selectors';

@Injectable({
  providedIn: 'root',
})
export class AddressGuard {
  constructor(private store: Store) {}

  canActivate(): Observable<boolean | Promise<boolean>> {
    return this.checkLastAdd();
  }

  checkLastAdd(): Observable<boolean> {
    return this.store.select(selectCartLoadingState).pipe(
      filter(loading => !loading), // only emit when add to cart request is done
      withLatestFrom(
        this.store.select(selectFailedAddons),
        this.store.select(selectCheckEmptyCart),
        this.store.select(selectEnableAddressCollection),
        this.store.select(selectCurrentRegistration),
      ),
      switchMap(
        ([, failedAddons, emptyCart, addressCollectionEnabled, currentReg]) => {
          if (failedAddons.length > 0) {
            this.store.dispatch(navToFailedAddons());
            return of(false);
          }

          if (emptyCart || !addressCollectionEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            currentReg?.system !== 'Motion' &&
              this.store.dispatch(completeOrder());
            return of(false);
          }
          return of(true);
        },
      ),
    );
  }
}
